<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">作品管理</span>
      </div>
    </div>
    <div class="b1top">
      <div class="b1tl">
        <span style="font-weight: bold;">正式课程资源</span>
      </div>
    </div>
    <div class="listbox">
      <table>
        <thead>
          <tr>
            <th style="width:100px">资源封面</th>
            <th>资源名称</th>
            <th style="width:64px">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in storeList"
              :key="index">
            <td>
              <img :src="item.acr_PictResUrl"
                   style="width:65px;height:45px;margin:15px"
                   alt="">
            </td>
            <td>{{item.title}}</td>
            <td>
              <span @click="toShow2(item.id)"
                    style="cursor: pointer;color:#0b8586">查看</span>
            </td>
          </tr>
          <tr v-show="storeList.length<1">
            <td colspan="4">暂无资源信息</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination :total="pageCount"
                :limit="pageSize"
                :page="pageIndex"
                @page-change="pageChange"></pagination>
  </div>
</template>

<script>
export default {
  name: 'usManagement',
  data () {
    return {
      storeList: [],
      draftNum: 0,
      pageCount: 0,
      pageSize: 6,
      pageIndex: 1,
    };
  },
  created () {
    this.GetMyStoreList()
  },
  methods: {
    pageChange (page) {
      if (page == this.pageIndex) {
        return;
      }
      this.pageIndex = page;
      this.GetMyStoreList()
    },
    GetMyStoreList () {
      this.httphelper.get('/api/CGPEnterPriseApi/GetCourseSource', {
        Id: Number(localStorage.getItem('storeId')),
        Suurce: 1,
        // Id: Number(40),
        page: this.pageIndex,
        limit: this.pageSize
      })
        .then(res => {
          if (res.code == 200) {
            if (res.data != null) this.storeList = res.data
            this.pageCount = res.totalcount
          }
        });
    },
    toShow2 (id) {
      window.open(this.httphelper.IsDebugCgphome()+'/detail?courseId=' + id, "_blank")
    }
  }
};
</script>

<style scoped>
.listbox {
    width: 100%;
}
.listbox table {
    width: 100%;
    border-collapse: collapse;
}
.listbox th {
    height: 44px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    border-color: #e2e2e2;
    border: 1px solid #e2e2e2;
}
.listbox td {
    height: 58px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    background: #fafafa;
    text-align: center;
    border: 1px solid #e2e2e2;
}
.b1top {
    margin: 20px 0;
    height: 18px;
    line-height: 18px;
    padding-left: 14px;
    border-left: 2px solid #0b8586;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.b1top span {
    margin-right: 40px;
    cursor: pointer;
}
</style>